import type { SessionDataType } from '@confluence/session-data/entry-points/SessionDataTypes.ts';

export const buildLoomMeetingsUrl = ({
	cloudId,
	environment,
}: Pick<SessionDataType, 'cloudId' | 'environment'>): string => {
	const loomOrigin = environment === 'PRODUCTION' ? 'https://loom.com' : 'https://stage.loom.com';

	return `${loomOrigin}/workspace/cloud/${encodeURIComponent(cloudId)}/meetings`;
};
